import { useMemo } from 'react';
import { Box, Flex, Checkbox } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { getAttachmentKey, formatAttachmentType } from './helpers';
import '@/components/formBuilder/styles/checkbox.css';

export const AttachmentList = ({
  attachments,
  searchQuery,
  selectedAttachments,
  existingDocuments,
  onToggle,
}) => {
  const filtered = useMemo(
    () =>
      attachments.filter((att) =>
        att.filename.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [attachments, searchQuery]
  );

  if (filtered.length === 0) {
    return (
      <KText size="sm-regular" color="secondary-500" py="8px">
        No documents found
      </KText>
    );
  }

  return (
    <Flex flexDirection="column">
      {filtered.map((attachment, idx) => {
        const key = getAttachmentKey(attachment);
        const isSelected = selectedAttachments.some(
          (a) => getAttachmentKey(a) === key
        );
        const isAlreadyAdded = existingDocuments.some(
          (a) => getAttachmentKey(a) === key
        );
        const isLast = idx === filtered.length - 1;

        return (
          <Box
            key={key}
            py="12px"
            borderBottom={isLast ? 'none' : '1px solid'}
            borderColor="border-color"
            opacity={isAlreadyAdded ? 0.6 : 1}
          >
            <Checkbox
              className="custom_checkbox"
              isChecked={isSelected || isAlreadyAdded}
              isDisabled={isAlreadyAdded}
              onChange={() => !isAlreadyAdded && onToggle(attachment)}
              size="md"
              w="100%"
              spacing="12px"
            >
              <Flex alignItems="center" gap="6px">
                <KText size="sm-medium" color="secondary-800" maxW="100%">
                  {formatAttachmentType(attachment.type)}
                </KText>
                <KText
                  size="sm-regular"
                  color="secondary-500"
                  isTruncated
                  maxW="150px"
                  enableTooltip
                >
                  ({attachment.filename})
                </KText>
              </Flex>
            </Checkbox>
          </Box>
        );
      })}
    </Flex>
  );
};
